import DefaultInfo from './DefaultInfo.vue'
import AssessInfo from './AssessInfo.vue'
import LinkScraping from './LinkScraping.vue'
import ContentScraping from './ContentScraping.vue'
import CorporateInformation from './corporate-information/CorporateInformation.vue'
import AIScraping from './ai-scraping/AIScraping.vue'
import ReportResult from './report-result/ReportResult.vue'

export default {
  DefaultInfo,
  AssessInfo,
  LinkScraping,
  ContentScraping,
  CorporateInformation,
  AIScraping,
  ReportResult
}
